import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { post } from '../../Auths/AuthToken';
import ReactDatePicker from 'react-datepicker';
import { DEFAULT_DATE_FORMATE } from '../../../constents';
import setUiMessage from '../../../Utilities/Tostify';
import ViewReportEligibilityPopup from './ViewReportEligibilityPopup';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';

const CheckEligibilityPopup = ({
  patientId,
  appId = 0,
  insId = '',
  flag,
  setCheckEligibilityPopup,
  handleReload,
}) => {
  const { user } = useSelector((state) => state.auth);

  const [allData, setAllData] = useState(null);
  const [allProvider, setallProvider] = useState(null);
  const [selProvProvider, setSelProvProvider] = useState('');
  const [selProvComp, setSelProvComp] = useState('');
  const [companyName, setCompanyName] = useState(null);
  const [patientInsuranceList, setpatientInsuranceList] = useState(null);
  const [insuranceId, setInsuranceId] = useState('');
  const [radioValue, setRadioValue] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [prevElgCheckInfo, setPrevElgCheckInfo] = useState({});
  const [appDatePickerIsOpen, setAppDatePickerIsOpen] = useState(false);
  const [viewReportEligibilityPopup, setViewReportEligibilityPopup] =
    useState(false);
  const [eligid, setEligid] = useState('');
  const [checkEligibilityFlag, setCheckEligibilityFlag] = useState(false);

  function openDatePicker() {
    setAppDatePickerIsOpen(!appDatePickerIsOpen);
  }

  function handleDateSelect(dateEvent) {
    setAppDatePickerIsOpen(!appDatePickerIsOpen);
  }

  const handleEligibilityViewReport = () => {
    setEligid(eligId);
    setViewReportEligibilityPopup(!viewReportEligibilityPopup);
  };

  const {
    checkedDate,
    checkedTime,
    elig_check_flag,
    insName,
    polNumber,
    copay,
    effectiveDate,
    deductible,
    eligId,
  } = prevElgCheckInfo;

  useEffect(() => {
    (async () => {
      try {
        const response = await post(
          'api/appointment/Appointment/checkEligibility',
          {
            patientId: patientId,
            appId: appId,
            triggerFrom: flag === 1 ? 1 : 0,
            insId: insId,
          }
        );

        if (response?.status === 200) {
          setAllData(response?.data);

          setallProvider(response?.data?.allProvider);
          setCompanyName(response?.data?.serviceLocationList);
          setpatientInsuranceList(response?.data?.patInsList);
          setPrevElgCheckInfo(response?.data?.prevElgCheckInfo);
          setSelectedDate(
            response?.data?.apptDate
              ? new Date(response?.data?.apptDate)
              : new Date()
          );

          if (!insId) {
            setInsuranceId(response?.data?.appInsArr.id);
          } else {
            setInsuranceId(insId);
          }
          setRadioValue(parseInt(response?.data?.defaultEligOption));
          if (parseInt(response?.data?.defaultEligOption) !== 1) {
            setSelProvProvider(response?.data?.receiver_id);
          } else {
            setSelProvComp(response?.data?.receiver_id);
          }
          // setPcpCoPayAmount(
          //   response?.data?.prevElgCheckInfo?.copay[0]?.benefit_amount
          // );
        }
      } catch (err) {}
    })();
  }, [patientId, appId, flag, insId]);

  const handleSaveCheckEligibility = async () => {
    if (!insuranceId) {
      setUiMessage('err', 'Please select Insurance');
    }
    if (radioValue === 0 && !selProvProvider) {
      setUiMessage('err', 'Please select Provider');
    }
    if (radioValue === 1 && !selProvComp) {
      setUiMessage('err', 'Please select Company');
    }
    if (!selectedDate) {
      setUiMessage('err', 'Please select DOS');
    }
    if (insuranceId && (selProvProvider || selProvComp) && selectedDate) {
      try {
        const response = await post(
          'api/appointment/Appointment/saveEligiblity',
          {
            insuranceId: insuranceId,
            clinicId: radioValue === 0 ? selProvProvider : selProvComp,
            patientId: patientId,
            apptId: appId,
            eqServiceTypeCode: 30,
            typeId: radioValue,
            serviceDate: format(selectedDate, DEFAULT_DATE_FORMATE),
            triggerFrom: flag,
            loginUserId: user?.id,
          }
        );
        if (response?.status === 200) {
          setCheckEligibilityFlag(true);
          if (response?.data?.prevElgCheckInfo) {
            setPrevElgCheckInfo(response?.data?.prevElgCheckInfo);
          } else {
            setUiMessage('err', 'No data found.');
          }
        }
      } catch (err) {
        setUiMessage('err', err?.message);
      }
    }
  };

  const handleUpdatePcpCopayInPatIns = async (pcpCoPayAmount, insuranceId) => {
    try {
      const response = await post(
        'api/appointment/Appointment/updatePcpCopayInPatIns',
        {
          insuranceId: insuranceId,
          amount: pcpCoPayAmount,
        }
      );
      if (response?.status === 200) {
      }
    } catch (err) {}
  };

  const handleUpdateSpCopayInPatIns = async (pcpCoPayAmount, insuranceId) => {
    try {
      const response = await post(
        'api/appointment/Appointment/updateSpCopayInPatIns',
        {
          insuranceId: insuranceId,
          amount: pcpCoPayAmount,
        }
      );
      if (response?.status === 200) {
      }
    } catch (err) {}
  };

  const handleUpdateDedInPatIns = async (pcpCoPayAmount, insuranceId) => {
    try {
      const response = await post(
        'api/appointment/Appointment/updateDedInPatIns',
        {
          insuranceId: insuranceId,
          amount: pcpCoPayAmount,
        }
      );
      if (response?.status === 200) {
      }
    } catch (err) {}
  };

  return (
    <div className="modalBackground">
      <div className="main-contnr eligblty-po-up qhide">
        <div className="main-contnr-hdr flex-sec">
          <div className="hdr-pt-info">
            {allData?.patientFullName} <span className="red">|</span> ID:
            {allData?.chartNo}
            <span className="red"> | </span> {allData?.patYearGen}
            <span className="red"> | </span> Dob:{allData?.dob}
          </div>
          <span
            className="right red bold"
            onClick={() => {
              setCheckEligibilityPopup(false);
              if (checkEligibilityFlag) handleReload();
            }}
          >
            X
          </span>
        </div>
        <div className="main-contnr-bdy">
          <div className="hdr-sb-title">
            <span className="sb-titl-hdng">Check Eligibility:</span>
          </div>
          <div className="flex-sec">
            <div className="contnr-bdy-rw flex-sec">
              <span className="inpt-lbl clear-left15 clear-top5">
                <input
                  type="radio"
                  className=""
                  name="elgbltyCheck"
                  checked={radioValue === 0}
                  onChange={() => {
                    setRadioValue(0);
                    setSelProvComp('');
                  }}
                />
              </span>
              <span className="txt-label clear-top5">Provider:</span>
              <span className="txt-val">
                <select
                  className="dd-width"
                  disabled={radioValue !== 0}
                  value={selProvProvider}
                  onChange={(e) => setSelProvProvider(e.target.value)}
                >
                  <option value="">Select Provider</option>
                  {allProvider &&
                    allProvider.map((item, idx) => {
                      return (
                        <option key={idx} value={item?.id}>
                          {item?.provName}
                        </option>
                      );
                    })}
                </select>
              </span>
            </div>
            <div className="contnr-bdy-rw flex-sec">
              <span className="txt-label clear-top5">Insurance:</span>
              <span className="txt-val">
                {/*{!isInsuranceSelected && (
                  <p className="red">Please Select Insurance.</p>
                )}*/}
                <select
                  className="dd-width"
                  value={insuranceId}
                  onChange={(e) => setInsuranceId(e.target.value)}
                >
                  <option value="">Select Insurance</option>
                  {patientInsuranceList &&
                    patientInsuranceList.map((ele, index) => {
                      return (
                        <option key={index} value={ele?.id}>
                          {ele?.payerName}
                        </option>
                      );
                    })}
                </select>
              </span>
            </div>
          </div>
          <div className="flex-sec">
            <div className="contnr-bdy-rw flex-sec">
              <span className="inpt-lbl clear-left15 clear-top5">
                <input
                  type="radio"
                  className=""
                  name="elgbltyCheck"
                  checked={radioValue === 1}
                  onChange={() => {
                    setRadioValue(1);
                    setSelProvProvider('');
                  }}
                />
              </span>
              <span className="txt-label clear-top5">Company:</span>
              <span className="txt-val">
                <select
                  className="dd-width"
                  disabled={radioValue !== 1}
                  value={selProvComp}
                  onChange={(e) => setSelProvComp(e.target.value)}
                >
                  <option value="">Select Company</option>
                  {companyName &&
                    companyName.map((ele, index) => {
                      return (
                        <option key={index} value={ele?.id}>
                          {ele?.company_name}
                        </option>
                      );
                    })}
                </select>
              </span>
            </div>
            <div className="contnr-bdy-rw flex-sec">
              <span className="txt-label clear-top5">DOS:</span>

              <ReactDatePicker
                selected={selectedDate}
                onChange={(date) => setSelectedDate(date)}
                onClickOutside={openDatePicker}
                open={appDatePickerIsOpen}
                onSelect={handleDateSelect}
                className="app-date-picker"
                dateFormat={DEFAULT_DATE_FORMATE}
              />
              <img
                width="10%"
                src="./images/calendar-icon.png"
                alt=""
                onClick={openDatePicker}
                style={{ marginLeft: '10px' }}
              />
            </div>
          </div>
          <div
            className="contnr-bdy-rw flex-sec"
            style={{ flexDirection: 'row-reverse' }}
          >
            <button
              className="actn-yes"
              style={{ width: '120px', marginRight: '22px' }}
              onClick={() => handleSaveCheckEligibility()}
            >
              Check Eligibility
            </button>
          </div>
          <div className="chek-elgblty-inr-bdy">
            <div className="hdr-sb-title">
              <span className="sb-titl-hdng">Last Checked:</span>
            </div>

            <div className="flex-sec">
              <div className="contnr-bdy-rw flex-sec width100">
                <span
                  className="txt-label clear-top5 sec-colr"
                  style={{ width: '155px' }}
                >
                  Checked:
                </span>
                {checkedDate && checkedTime && (
                  <>
                    <span className="txt-val-view">
                      {checkedDate}, {checkedTime} |{' '}
                      <Link onClick={handleEligibilityViewReport}>
                        View Report
                      </Link>
                      {viewReportEligibilityPopup && (
                        <ViewReportEligibilityPopup
                          eligId={eligid}
                          patFullname={allData?.patientFullName}
                          patId={allData?.chartNo}
                          patDob={allData?.patYearGen}
                          patYearGen={allData?.patYearGen}
                          setViewReportEligibilityPopup={
                            setViewReportEligibilityPopup
                          }
                        />
                      )}
                    </span>
                    <span className="txt-val-view flex-sec">
                      {elig_check_flag === '1' ? (
                        <>
                          <span className="left elgblty-chck-stats">
                            &#10003;
                          </span>
                          <span className="left">Eligible for coverage</span>
                        </>
                      ) : elig_check_flag === '2' ? (
                        <>
                          <span className="left elgblty-inactv-stats">!</span>
                          <span className="left">Error</span>
                        </>
                      ) : elig_check_flag === '3' ? (
                        <>
                          <span className="left elgblty-inactv-stats">!</span>
                          <span className="left">In-Active</span>
                        </>
                      ) : (
                        <>
                          <span className="left elgblty-inactv-stats">!</span>
                          <span className="left">Not Available</span>
                        </>
                      )}
                    </span>
                  </>
                )}
              </div>
            </div>
            <div className="flex-sec">
              <div className="contnr-bdy-rw flex-sec width60">
                <span className="txt-label clear-top5 sec-colr">Payor:</span>
                <span className="txt-val-view">{insName}</span>
              </div>
              <div className="contnr-bdy-rw flex-sec width40">
                <span className="txt-label clear-top5 sec-colr">
                  Insurance ID:
                </span>
                <span className="txt-val-view">{polNumber}</span>
              </div>
            </div>

            <div className="hdr-sb-title">
              <span className="sb-titl-hdng">Co-Pay Info:</span>
            </div>
            <div className="contnr-bdy-rw grid-sec">
              {copay &&
                copay.map((ele, index) => {
                  //setPcpCoPayAmount(ele.benefit_amount);

                  return (
                    <div
                      key={index}
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <span className="clear-top5 width100 clear-left15 clear-top10 orange-txt">
                        {ele.benefits_coverage_level} {ele.benefit_amount} [
                        {ele.serviceCodeStr} ]
                      </span>
                      <span className="sec-colr width100 clear-left15 clear-top5">
                        Message: {ele.benefit_message}
                      </span>
                      <span className="sec-colr width100 clear-left15 clear-top5">
                        Do you want to update the above amount in patient's PCP
                        Co-pay?
                        <Link
                          to="#"
                          onClick={() =>
                            handleUpdatePcpCopayInPatIns(
                              ele.benefit_amount,
                              insuranceId
                            )
                          }
                        >
                          [Click here]
                        </Link>
                      </span>
                      <span className="sec-colr width100 clear-left15 clear-top5">
                        Do you want to update the above amount in patient's
                        Specialist Co-pay? ';
                        <Link
                          to="#"
                          onClick={() =>
                            handleUpdateSpCopayInPatIns(
                              ele.benefit_amount,
                              insuranceId
                            )
                          }
                        >
                          [Click here]
                        </Link>
                      </span>
                    </div>
                  );
                })}
            </div>
            <div className="hdr-sb-title">
              <span className="sb-titl-hdng">Deductible Remaining:</span>
            </div>

            <div className="contnr-bdy-rw grid-sec">
              {deductible &&
                deductible.map((ele, index) => {
                  return (
                    <div
                      key={index}
                      style={{ display: 'flex', flexDirection: 'column' }}
                    >
                      <span className="clear-top5 width100 clear-left15 clear-top10 orange-txt">
                        {ele.benefits_coverage_level}
                        {ele.benefit_amount} [{ele.serviceCodeStr} ]
                      </span>
                      <span className="sec-colr width100 clear-left15 clear-top5">
                        Message: {ele.benefit_message}
                      </span>
                      <span className="sec-colr width100 clear-left15 clear-top5">
                        Do you want to update the above amount in patient's
                        Deductible?
                        <Link
                          to="#"
                          onClick={() =>
                            handleUpdateDedInPatIns(
                              ele.benefit_amount,
                              insuranceId
                            )
                          }
                        >
                          [Click here]
                        </Link>
                      </span>
                    </div>
                  );
                })}
              <span className="contnr-bdy-rw flex-sec">
                <span className="txt-label clear-top5 sec-colr">
                  Effective:
                </span>
                <span className="txt-val-view"> {effectiveDate}</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckEligibilityPopup;
